import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { createEditorContentUnifiedQueryVariables } from '@confluence/editor-content-unified-query/entry-points/createEditorContentUnifiedQueryVariables.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { getDraftShareIdFromQueryParam } from '@confluence/route-manager-utils/entry-points/getDraftShareIdFromQueryParam.ts';

import useEmojiEverSetPropertyQuery from './emoji-title/__generated__/useEmojiEverSetPropertyQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadEmojiEverSetProperty = (
	contentId: string,
): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query({
		query: useEmojiEverSetPropertyQuery,
		variables: expValEquals('confluence_editor_content_unified_query', 'isEnabled', true)
			? createEditorContentUnifiedQueryVariables({
					contentId,
					draftShareId: getDraftShareIdFromQueryParam(),
				})
			: {
					contentId,
					status: ['current', 'draft'],
					draftShareId: getDraftShareIdFromQueryParam(),
				},
	});
};
